import { render, staticRenderFns } from "./ObjectViewItem.vue?vue&type=template&id=ef2960aa&scoped=true&"
import script from "./ObjectViewItem.vue?vue&type=script&lang=js&"
export * from "./ObjectViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectViewItem.vue?vue&type=style&index=0&id=ef2960aa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2960aa",
  null
  
)

export default component.exports